import { intervalToDuration } from 'date-fns';
import { useEffect, useState } from 'react';

import { getNextEpochStartTimestamp } from '../epoch';
import { useTimer } from '../timerCtx';

export const useTimeUntilNextDayEpoch = () => {
  const { timestamp } = useTimer();
  const [nextDayEpochStartTime, setNextDayEpochStartTime] = useState(0);

  useEffect(() => {
    const nextDayEpochStartTime = getNextEpochStartTimestamp();
    setNextDayEpochStartTime(Number(nextDayEpochStartTime));
  }, [timestamp]);

  return intervalToDuration({
    start: Number(timestamp * 1000n),
    end: nextDayEpochStartTime * 1000,
  });
};
